/**
 * Canonical Role enum (ADR-001).
 *
 * The five-level hierarchy used across persons, events, sessions, event
 * participants, audiences, and Auth custom claims. This file is the single
 * source of truth — every other schema importing a Role pulls from here.
 *
 * Kept in its own file so the role enum has zero schema-layer dependencies,
 * breaking any cycle that would otherwise form between identity schemas and
 * the schemas that reference Role (events, sessions, audiences).
 */

import { z } from 'zod';

export const ROLES = [
  'admin',
  'organizer',
  'internal',
  'invitee',
  'companion',
] as const;

/** Role enum — single source of truth for the five-level hierarchy (ADR-001). */
export const roleSchema = z.enum(ROLES);
